import AmbassadorsPager from './AmbassadorsPager'

export default AmbassadorsPager
